import { ApiFailure } from './api';

export interface ImportError {
  line: number;
  field: string;
  message: string;
}

export interface ImportDuplicate {
  line: number;
  // SIRET pour les entreprises, null pour les particuliers (identifiés par le
  // triplet nom+prénom+DDN - `identity` affiche le nom humain).
  siret: string | null;
  identity: string;
  type: 'company' | 'individual';
  existingProspectId: string;
  assignedTo: { id: string; firstName: string; lastName: string; email: string } | null;
}

export interface ImportReport {
  imported: number;
  skipped: number;
  totalLines: number;
  errors: ImportError[];
  duplicates: ImportDuplicate[];
  importedProspectIds: string[];
  warnings: Array<{ line: number | null; message: string }>;
}

/**
 * Upload `file` vers POST /api/v1/import/prospects. On utilise `FormData`
 * natif + `fetch` directement (pas le helper `api.ts`) pour piloter la
 * progression et manipuler l'erreur `413` personnalisée.
 */
export async function importProspects(accessToken: string, file: File): Promise<ImportReport> {
  const form = new FormData();
  form.append('file', file);

  const res = await fetch('/api/v1/import/prospects', {
    method: 'POST',
    credentials: 'include',
    headers: { Authorization: `Bearer ${accessToken}` },
    body: form,
  });

  const text = await res.text();
  const data = text ? (JSON.parse(text) as unknown) : null;

  if (!res.ok) {
    const errBody = (data as { error?: { code: string; message: string } } | null)?.error ?? {
      code: 'INTERNAL_ERROR',
      message: 'Import refusé',
    };
    throw new ApiFailure(res.status, errBody);
  }
  return data as ImportReport;
}
